import { CaseReducer, PayloadAction } from '@reduxjs/toolkit';
import { RadiusFilterOption, RadiusFilterState } from './radius.types';

export const createChangeRadiusFilterReducer =
  <State extends RadiusFilterState>(): CaseReducer<State, PayloadAction<RadiusFilterOption>> =>
  (state, action) => {
    state.currentRadius = action.payload;
  };
